module.exports = __webpack_public_path__ + "static/media/backgroundphoto.9a4af527.png";